module.exports = __webpack_public_path__ + "img/blockables-instructions-0.95f4402b.png";